<ng-container *ngFor="let item of items">
  <p
    *ngIf="item.htmlTag === 'p' || !item.htmlTag"
    [class]="
      'my-0 typo-text-emphasis-1-mobile lg:typo-text-emphasis-1-desktop ' +
      (item.cssClass || '')
    "
    [attr.aria-hidden]="ariaHidden ? 'hidden' : null">
    <ng-container *ngTemplateOutlet="content"></ng-container>
  </p>
  <div
    *ngIf="item.htmlTag === 'div'"
    [class]="'my-0 ' + (item.cssClass || '')"
    [attr.aria-hidden]="ariaHidden ? 'hidden' : null">
    {{ item.value }}
  </div>
  <h1
    *ngIf="item.htmlTag === 'h1'"
    [class]="'my-0 ' + (item.cssClass || '')"
    [attr.aria-hidden]="ariaHidden ? 'hidden' : null">
    {{ item.value }}
  </h1>
  <h2
    *ngIf="item.htmlTag === 'h2'"
    [class]="'my-0 ' + (item.cssClass || '')"
    [attr.aria-hidden]="ariaHidden ? 'hidden' : null">
    {{ item.value }}
  </h2>
  <h3
    *ngIf="item.htmlTag === 'h3'"
    [class]="'my-0 ' + (item.cssClass || '')"
    [attr.aria-hidden]="ariaHidden ? 'hidden' : null">
    {{ item.value }}
  </h3>
  <h4
    *ngIf="item.htmlTag === 'h4'"
    [class]="'my-0 ' + (item.cssClass || '')"
    [attr.aria-hidden]="ariaHidden ? 'hidden' : null">
    {{ item.value }}
  </h4>

  <ng-template #content>
    <ng-container *ngIf="item.translationKey; else noTranslation">{{
      item.translationKey | translate: item.value
    }}</ng-container>
  </ng-template>
  <ng-template #noTranslation>{{ item.value }}</ng-template>
</ng-container>

<span *ngIf="listAriaLabel" class="sr-only">{{ listAriaLabel }}</span>
